export default __webpack_public_path__ + "static/media/js-bg.5154f076.svg";